import axios from 'axios';
import { stringify } from 'qs';
var service = {
    request: axios.create({
        baseURL: '/',
        timeout: 10000,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
};
service.request.interceptors.request.use(function (config) {
    var token = config.data.token;
    var hciToken = '';
    if (!config.multi) {
        config.data = stringify(config.data.data);
    }
    if (token) {
        config.headers.Token = token;
        if (hciToken)
            config.headers['HCI-TOKEN'] = hciToken;
    }
    return config;
}, function (error) {
    console.log(error);
    Promise.reject(error);
});
service.request.interceptors.response.use(function (response) {
    if (response.data.code <= 0) {
        return Promise.reject(response.data);
    }
    return response.data;
}, function (error) {
    console.log('err' + error);
    return Promise.reject(error);
});
export default service;